export default __webpack_public_path__ + "static/media/dashboard_no_data_found.fb3df131.svg";